/**
 * @ngdoc object
 * @name eventix.common.services.Locales
 * @description
 * Global array of available locales for events, also functions as a storage
 * facility to persist language settings across sessions.
 *
 * <pre>
 * [{label: 'Nederland', code: 'nl_NL'}]
 * </pre>
 */
export default angular.module('eventix.common.services.locales', [])
    .provider('Locales', function() {
        const provider = this;
        const Locales = [{
            label: 'Great Britain',
            translation: true,
            moment: 'en-gb',
            code: 'en_GB'
        }, {
            label: 'United States',
            translation: false,
            moment: 'en',
            code: 'en_US'
        }, {
            label: 'België',
            translation: false,
            moment: 'nl-be',
            code: 'nl_BE'
        }, {
            label: 'Nederland',
            translation: true,
            moment: 'nl',
            code: 'nl_NL'
        }, {
            label: 'Italiano',
            translation: true,
            moment: 'it',
            code: 'it_IT'
        }, {
            label: 'France',
            translation: true,
            moment: 'fr',
            code: 'fr_FR'
        }, {
            label: '中文',
            translation: true,
            moment: 'zh-cn',
            code: 'zh_CN'
        }, {
            label: 'Deutsch',
            translation: true,
            moment: 'de',
            code: 'de_DE'
        }, {
            label: 'España',
            translation: true,
            moment: 'es',
            code: 'es_ES'
        },{
            label: 'Australia',
            translation: false,
            moment: 'en',
            code: 'en_AU'
        }];

        provider.available = _.map(Locales, 'code');
        provider.mapping = {};
        _.forEach(_.filter(Locales, { translation: true }), locale => {
            let newCode = locale.code.slice(0,2) + '_*';
            provider.mapping[newCode] = locale.code;
        });
        provider.mapping['*'] = 'en_GB';
        provider.$get = /*@ngInject*/function(store) {
            _.forEach(Locales, l => {
                l.icon = 'flag-icon flag-icon-' + l.code.slice(-2).toLowerCase();
            });
            var selected = store.get('NG_TRANSLATE_LANG_KEY');
            if (selected)
                moment.locale(_.get(_.find(Locales, { code: selected }), 'moment', 'en'));

            Object.defineProperties(Locales, {
            /**
             * @ngdoc property
             * @name eventix.common.services.Locales#selected
             * @propertyOf eventix.common.services.Locales
             * @description
             * Locale setting
             */
                selected: {
                    get: () => selected,
                    set: l => {
                        if (_.isString(l))
                            moment.locale(_.get(_.find(Locales, { code: l }), 'moment', 'en'));
                        return selected = l;
                    },
                    enumerable: false
                },
                /**
             * @ngdoc method
             * @name eventix.common.services.Locales#put
             * @methodOf eventix.common.services.Locales
             * @description
             * Save a language setting
             *
             * @example
             * <pre>
             * Locales.put('NL_TRANSLATE_LANG_KEY','nl_NL');
             * </pre>
             *
             * @param {String} name The setting to save
             * @param {String} value The value to save
             */
                put: {
                    value: function(name, value) {
                        if (name === 'NG_TRANSLATE_LANG_KEY')
                            this.selected = value;
                        return store.set(name, value);
                    },
                    enumerable: false
                },
                /**
             * @ngdoc method
             * @name eventix.common.services.Locales#get
             * @methodOf eventix.common.services.Locales
             * @description
             * Fetch a language setting
             *
             * @example
             * <pre>
             * Locales.get('NL_TRANSLATE_LANG_KEY');
             * </pre>
             *
             * @param {String} name The setting to fetch
             * @returns {String} The value stored at `name`
             */
                get: {
                    value: function(name) {
                        var value = store.get(name);
                        if (name === 'NG_TRANSLATE_LANG_KEY')
                            this.selected = value;
                        return value;
                    },
                    enumerable: false
                }
            });
            return Locales;
        };
    }).name;
